import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'
import {
	addSubtractPayloadModel,
	spWalletFilter,
	adminWalletTotalPayload,
	clientWalletListFilter,
} from 'src/app/modules/wallet/models/wallet.models'
import { financeFilter } from 'src/app/modules/wallet/models/finance.models'
@Injectable({
	providedIn: 'root',
})
export class WalletService {
	constructor(private http: HttpClient) {}

	getSpWalletList(body: any) {
		return this.http.post(`${ApiEndPoint.GetSpWalletListApi}`, body)
	}
	getTotalBalanceWalletList(body: any) {
		return this.http.post(`${ApiEndPoint.GetTotalBalanceWalletListApi}`, body)
	}
	addFundToWallet(body: addSubtractPayloadModel) {
		return this.http.post(`${ApiEndPoint.AddToWalletApi}`, body)
	}
	subtractFundFromWallet(body: addSubtractPayloadModel) {
		return this.http.post(`${ApiEndPoint.SubtractFromWalletApi}`, body)
	}
	getSpWalletData(id: number) {
		return this.http.get(`${ApiEndPoint.SpWalletData}?branchId=${id}`)
	}
	getSpWalletTransactionList(body: spWalletFilter) {
		return this.http.post(`${ApiEndPoint.SpGetWalletTransactionListApi}`, body)
	}
	getAdminWalletTotal(body: any) {
		return this.http.post(`${ApiEndPoint.GetAdminWalletTotalApi}`, body)
	}
	getClientWalletList(body: any) {
		return this.http.post(`${ApiEndPoint.GetClientWalletListApi}`, body)
	}
	getFinanceList(body: financeFilter) {
		return this.http.post(`${ApiEndPoint.GetFinanceList}`, body)
	}
}
